import { HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { UsersService } from 'src/app/shared/service/users/users.service';

@Component({
  selector: 'app-dynamic-file',
  templateUrl: './dynamic-file.component.html',
  styleUrls: ['./dynamic-file.component.scss']
})
export class DynamicFileComponent implements OnInit {
  @Input() field: any;
  formName: FormGroup;

  imageUrl?: any;

  fileExists: boolean = false;

  dynamicWidth = '80%';

  constructor(
    private formgroupDirective: FormGroupDirective,
    private usersService: UsersService
  ) {
    this.formName = formgroupDirective.control;
  }

  ngOnInit(): void {

    const field = this.field.fieldName;

    this.formName.valueChanges.subscribe((files: any) => {
      if (files.Imagen !== '') {
        if (!Array.isArray(files[field])) {
          let formData = new FormData();
          let filesData = [files]
          console.log(filesData)
          formData.append('myfile', filesData[0].Imagen, filesData[0].Imagen.name);
          formData.append('type', 'Usuarios');
          this.usersService.uploadImage(formData).subscribe({
            next: (event: HttpEvent<any>) => {
              if (event.type === HttpEventType.UploadProgress) {
                if (event.total! > 0) {
                  (event as any).percent = (event.loaded / event.total!) * 100;
                }
              } else if (event instanceof HttpResponse) {
                this.fileExists = true;
                this.imageUrl = event.body.data.url
                files.Imagen = event.body.data.url;
              }
            },
            error: error => {
            }
          })
        } else {
          console.log('no')
        }
      } else {
        'no'
      }
    })
  }

}
